import React from 'react';

import { Button, Flex, Text } from '@chakra-ui/react';
import type { ButtonProps } from '@chakra-ui/react';

/**
 * Props for the FormButton component
 * @interface FormButtonProps
 */
interface FormButtonProps {
  /** Button children content */
  children?: React.ReactNode;
  /** Button properties to spread */
  button?: ButtonProps;
  /** Button title text */
  title?: string;
  /** Button ID for tracking */
  id?: string;
  /** Click handler function */
  handler?: React.MouseEventHandler<HTMLButtonElement>;
}

/**
 * Styled button component for forms with consistent styling
 * 
 * @component
 * @param {FormButtonProps} props - Component props
 * @returns {React.ReactElement} Styled button component
 */
const FormButton = ({ children, button, title, id, handler }: FormButtonProps): React.ReactElement => {
  return (
    <Button
      id={id}
      variant={'unstyled'}
      w={'100%'}
      h={'36px'}
      py={'11px'}
      px={'24px'}
      fontSize={'14px'}
      fontWeight={700}
      lineHeight={'normal'}
      color={'white'}
      borderRadius={'4px'}
      bg={'mainBlue'}
      _hover={{ bg: 'blue' }}
      _disabled={{ bg: 'disabledBg' }}
      onClick={handler}
      {...button}
    >
      {title ? <Text mt={'2px'}>{title}</Text> : null}
      {children ? (
        <Flex mt={'2px'} w={'100%'} justifyContent={'center'} h={'100%'}>
          {children}
        </Flex>
      ) : null}
    </Button>
  );
};

export default FormButton;
